import { render, staticRenderFns } from "./TradeHistory.vue?vue&type=template&id=dbbb1656&scoped=true"
import script from "./TradeHistory.vue?vue&type=script&lang=js"
export * from "./TradeHistory.vue?vue&type=script&lang=js"
import style0 from "./TradeHistory.vue?vue&type=style&index=0&id=dbbb1656&prod&lang=scss"
import style1 from "./TradeHistory.vue?vue&type=style&index=1&id=dbbb1656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbb1656",
  null
  
)

export default component.exports